var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tag',{staticClass:"is-info",attrs:{"ellipsis":""}},[_vm._v(_vm._s(_vm.tag.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }